var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgType2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.2626 0 0 .24592 -3.5 -22.7)",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.3,
    cy: 215,
    rx: 13.3,
    ry: 13.1,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 13.1,
    rx: 13.3,
    cy: 215,
    cx: 77.7,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.6,
    cy: 179.5,
    rx: 13.3,
    ry: 13.1,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 13.1,
    rx: 13.3,
    cy: 179.5,
    cx: 99,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.7,
    cy: 179.5,
    rx: 13.3,
    ry: 13.1,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 10.1,
    rx: 9.7,
    cy: 150.7,
    cx: 120,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2,
    cy: 150.7,
    rx: 9.7,
    ry: 10.1,
    strokeWidth: 9.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 120.9h85.2s9 6 12.7 10.3a82 82 0 0 1 9.9 14.4 77.2 77.2 0 0 1 10 31.7c.5 7-.2 16.4-1.8 23.4a74.6 74.6 0 0 1-15.7 29.8 93.9 93.9 0 0 1-27.6 21.6c-5.6 2.6-18.2 5.7-18.2 5.7s-17 2.3-30.7-2.5c-5.4-2-9-2.6-15-5.7-7.6-4-15-9-20.7-15.3A89.8 89.8 0 0 1 26.9 204c-3-8.8-4.1-18.5-3.8-27.9.3-7.1 2-14.2 4.4-20.9 2.1-5.7 5.7-11.1 8.8-15.8 3-4.7 8.4-9.7 12-12.7 3.5-3 8.7-5.7 8.7-5.7z",
    strokeWidth: 16,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2);
export default __webpack_public_path__ + "static/media/type2.d69021a3a12e058d87ea5fbe0e0a038d.svg";
export { ForwardRef as ReactComponent };